import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const assuranceCards = [
	{
		title: 'Predictable sailings',
		content: 'Locked-in space with major carriers and defined ETAs.',
		icon: 'line-icon-Ship-2',
	},
	{
		title: 'Door-to-door control',
		content: 'Origin pickup, handoffs, and delivery with milestone updates.',
		icon: 'line-icon-Location-2',
	},
	{
		title: 'Customs confidence',
		content: 'Documentation, brokerage support, and compliance oversight.',
		icon: 'line-icon-Stamp',
	},
	{
		title: 'Cold chain & OOG',
		content: 'Reefer monitoring and project cargo support worldwide.',
		icon: 'line-icon-Temperature',
	},
];

const OceanTestimonials = () => {
	return (
		<m.section
			className='py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] overflow-hidden bg-lightgray'
			{...fadeIn}
		>
			<Container>
				<Row className='justify-center'>
					<Col
						lg={6}
						sm={8}
						xl={5}
						className='text-center mb-24 md-mb-20 sm:mb-12'
					>
						<span className='font-serif text-xmd mb-[20px] block text-fastblue font-medium'>
							Why shippers choose us
						</span>
						<h5 className='font-serif text-darkgray font-medium'>
							Service assurances built for ocean freight
						</h5>
					</Col>
					<Row className='row-cols-1 row-cols-md-2 row-cols-lg-4 gap-y-10 justify-center'>
						{assuranceCards.map((item, i) => (
							<Col key={item.title} className='flex justify-center'>
								<m.div
									className='bg-white text-center p-8 rounded-md shadow-[0_0_15px_rgba(0,0,0,0.08)] h-full max-w-[320px]'
									{...fadeIn}
									transition={{ delay: i * 0.1, duration: 0.6 }}
								>
									<div className='w-[120px] h-[120px] rounded-full bg-white shadow-[0_8px_25px_rgba(0,0,0,0.11)] flex items-center justify-center mx-auto mb-6'>
										<i
											className={`${item.icon} text-[46px] text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]`}
										></i>
									</div>
									<h6 className='font-serif text-darkgray font-medium mb-3'>
										{item.title}
									</h6>
									<p className='mb-0 text-md leading-7 text-[#6f6f6f]'>
										{item.content}
									</p>
								</m.div>
							</Col>
						))}
					</Row>
				</Row>
			</Container>
		</m.section>
	);
};

export default OceanTestimonials;
